import {Types} from "../../../type/Types";

export type ShoppingPathJointReportReasonValueObject = {
    id: bigint
    body: string
    createdAt: Date
    modifiedAt: Date | null
    deletedAt: Date | null
}

export namespace ShoppingPathJointReportReasonValueObject {
    export function construct(o: any): ShoppingPathJointReportReasonValueObject {
        return {
            id: BigInt(o.id),
            body: String(o.body),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof ShoppingPathJointReportReasonValueObject, string> = {
        id: 'ID',
        body: '내용',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
        deletedAt: '삭제 시각',
    }
}